export default {
    'form.Submit': "Submit",
    'form.cancel': "Cancel",
    'form.edit': "Edit",
    'form.view_table': "View in Table",
    'form.view_list': "View in List",
    'form.select_item': "Select {item} ",
    'form.picked_item': "Picked {item} ",
    "form.upload.text": "Click or drag a file here to upload.",
    "form.upload.hint": "Supports single or bulk upload. Uploading company data or restricted files is strictly prohibited.",
    'form.created_at': "Created At",
    'form.updated_at': "Updated At",
    'form.download': "Download",
    "form.editable": "Editable",

    'form.ev_charger.cha_id': "Id",
    'form.ev_charger.connectors.con_db_id': "Id",
    'form.ev_charger.connectors': "Connectors",
    'form.ev_charger.connectors.add': "Add Connector",
    'form.ev_charger.connectors.con_id': "Connector id",
    'form.ev_charger.connectors.ev_system': "System",
    'form.ev_charger.connectors.default_current': "Default Current",
    'form.ev_charger.connectors.min_current': "Min Current",
    'form.ev_charger.connectors.max_current': "Max Current",
    "form.ev_charger.connectors.id.not_unique": "Connector ID is already in use. Please provide a unique ID.",

    'form.document.selects': "Select Document(s)",
    'form.document.document': "Document",
    'form.document.uid': "ownerId",
    'form.document.did': "Id",
    'form.document.file': "File",
    'form.document.file_path': "Path",
    'form.document.file_name': "Name",
    'form.document.document_type': "Type",
    'form.document.filesize': "File Size",
    'form.document.view': "View",
    'form.document.null': "There is no related documents",

    "ev_schedule.sch_id": "Schedule ID",
    "ev_schedule.schedule_start": "Start Time",
    "ev_schedule.schedule_not_start": "Not Started",
    "ev_schedule.title": "Event Title",
    "ev_schedule.description": "Event Description",
    "ev_schedule.date_range": "Date Range",
    "ev_schedule.time_range": "Time Range",
    "ev_schedule.rate_method": "Rate Calculation Method",
    "ev_schedule.min_interval": "Minimum Interval",
    "ev_schedule.min_interval.d": "0 = No Limit",
    "ev_schedule.interval": "Interval",
    "ev_schedule.rate": "Rate",
    "ev_schedule.upper_limit_rate": "Maximum Rate",
    "ev_schedule.round_method": "Rounding Method",
    "ev_schedule.round_method.rounddown": "Round down",
    "ev_schedule.round_method.roundup": "Round up",
    "ev_schedule.round_method.round": "Round",
    "ev_schedule.round_method.notround": "Not Round",
    "ev_schedule.round_method.custom": "Custom Rounding",
    "ev_schedule.recurs": "Recurring On",
    'ev_schedule.mon': "Mon",
    'ev_schedule.tue': "Tue",
    'ev_schedule.wed': "Wed",
    'ev_schedule.thu': "Thu",
    'ev_schedule.fri': "Fri",
    'ev_schedule.sat': "Sat",
    'ev_schedule.sun': "Sun",
    'ev_schedule.public_holiday': "Public Holiday",
    'ev_schedule.priority': "Priority",

    "location.sch_id": "Id",
    'location.null': "There is no related locations for this charger.",
    'location.location_id': "ID",
    'location.name_en': "Name (EN)",
    'location.name_tc': "Name (TC)",
    'location.name_sc': "Name (SC)",
    'location.address_en': "Address (EN)",
    'location.address_tc': "Address (TC)",
    'location.address_sc': "Address (SC)",
    'location.public_description_en': "Description (EN)",
    'location.public_description_tc': "Description (TC)",
    'location.public_description_sc': "Description (SC)",
    'location.contact_no': "Contact No",
    'location.latitude': "Latitude",
    'location.longitude': "Longitude",
    'location.image': "Image",

    'playlist.null': "There is no related advertising for this charger.",
    'playlist.playlist': "Playlist",
    'playlist.ad_id': "Id",
    'playlist.title': "Title",
    'playlist.description': "Description",
    'playlist.uid': "ownerId",
    'playlist.document.did': "Id",
    'playlist.document.order': "Playback Order Number",
    'playlist.document.display_seconds': "Show Duration in Seconds",
};
